export default {
    cliente: "Cliente",
    equipo: "Equipo",
    problema: "Problema",
    accesorios: "Accesorios",
    agendado: "Agendado",
    fecha: "Fecha",
    tecnico: "Técnico",
    estado: "Estado",
    tipo: "Tipo",
    grado: "Grado",
    sucursal: "Sucursal",
    motivo: "Motivo",
    documento: "Documento",
    direccion: "Dirección",
    telefono: "Teléfono",
    email: "Correo electrónico",
    celular: "Celular",
    nombre: "Nombre",
    sucursalCliente: "Sucursal del cliente",
    localidad: "Localidad",
    estadoDepto: "Estado",
    pais: "País",
    contacto: "Contacto",
    codigo: "Código",
    nroParte: "Nro. Parte",
    codBarras: "Código de barras",
    descripcion: "Descripción",
    costo: "Costo",
    precio: "Precio",
    moneda: "Moneda",
    proveedor: "Proveedor",
    marca: "Marca",
    stock: "Stock",
    total: "Total",
    usuario: "Usuario",
    guia: "Guía",
    origen: "Origen",
    destino: "Destino",
    familia: "Familia",
    numSerie: "Número de serie",
    tipoEquipo: "Tipo de equipo",
    modelo: "Modelo",
    orden: "Orden",
    enviado: "Fecha enviado",
    recibido: "Fecha recibido",
    nroExpediente: "Nro. Expediente",
    rubro: "Rubro",
    vencimiento: "Vencimiento",
    tipoTecnico: "Tipo de técnico",
    nota: "Nota",
    repuesto: "Repuesto",
    informe: "Informe al cliente",  
    depto: "Departamento/Área",
    falla: "Falla"
}